import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { Lock } from 'lucide-react';

import { useAuthContext } from '../providers/AuthProvider.jsx';
import { canUseCustomizer } from '../../lib/permissions.js';

/**
 * Customizadores por rol (C3D-27). Va dentro de `RequireAuth`, que ya ha
 * cargado los permisos.
 *
 * Sin permiso no se empieza un diseño nuevo. Uno que ya existe se deja abrir
 * para verlo: guardarlo o regenerarlo lo rechaza el backend.
 */
const RequireCustomizer = ({ productType, children }) => {
    const authContext = useAuthContext();
    const { modelId } = useParams();

    if (modelId || canUseCustomizer(authContext, productType)) return children;

    return (
        <div className="flex h-full w-full items-center justify-center p-6">
            <div className="max-w-md text-center flex flex-col items-center gap-3">
                <Lock className="w-10 h-10 text-base-content/40" aria-hidden="true" />
                <h1 className="text-xl font-bold">Este customizador no está disponible</h1>
                <p className="text-sm text-base-content/70">
                    Tu cuenta no tiene acceso a este customizador. Si crees que debería,
                    escríbenos y lo revisamos.
                </p>
                <Link to="/customizers" className="btn btn-primary btn-sm">
                    Ver los customizadores disponibles
                </Link>
            </div>
        </div>
    );
};

RequireCustomizer.propTypes = {
    productType: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default RequireCustomizer;
